import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { NavBar } from './navbar'
import { Home } from './home'
import { Gallery } from './gallery'
import { Events } from './events'
import { Contact } from './contact'
import { Faqs } from './faqs'
import { Error } from './error'
import { Lawn } from './lawn'
import GoldenPackage from './Goldenpackage'
import SilverPackage from './Silverpackage'
import About from './about'
import Footer from './footer'
import { WhatsAppButton } from './whatsappbtn'
import { ScrollTop } from './scroltop'

export const Appmain = () => {
    return (
        <>
            <BrowserRouter>
                <NavBar />
                <ScrollTop />
                <WhatsAppButton />

                <Routes>
                    <Route>
                        <Route path="/" element={<Home />} />
                        <Route path="/gallery" element={<Gallery />} />
                        <Route path="/events" element={<Events />} />
                        <Route path="/lawn/:id" element={<Lawn />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/faq" element={<Faqs />} />
                        <Route path="/goldenpkg" element={<GoldenPackage />} />
                        <Route path="/silverpkg" element={<SilverPackage />} />
                        <Route path="/about" element={<About />} />
                        {/* <Route path="/error" element={<Error />} /> */}
                    </Route>
                </Routes>

                <Footer />
            </BrowserRouter>
        </>
    )
}
